/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import {useSelector} from 'react-redux';
import {CTCEntity} from '@ion/core/src/types/entities';

/**
 * Provides a utility hook for getting the bulk delete operation results for any entity via
 * its respective reducer ...
 *
 * ```typescript
 *
 *   import {useBulkDeleteResults} from '@ion/dls/src/hooks/';
 *   const bulkDeleteResult = useBulkDeleteResults('reducer');
 *
 * ```
 */
export const useBulkDeleteResults = (reducer: string): CTCEntity | CTCEntity[] => {
  return useSelector(({[reducer]: {bulkDelete}}) => bulkDelete?.result);
};

export default useBulkDeleteResults;
